import { TEditableDatePickerProps } from './EditableDatePicker.types';
import { SEditableDatePicker } from './EditableDatePicker.styles';

const EditableDatePicker = (props: TEditableDatePickerProps) => {
  return <SEditableDatePicker {...props} />;
};

export default EditableDatePicker;
